import React, { Fragment } from "react";
import { connect } from "react-redux";

import Alert from "@/components/generic/Alert";
import { removeAlert, getAllAlerts } from "./Alerts.state";

const Alerts = ({ alerts, closeAlert }) => (
  <Fragment>
    {alerts.map(({ id, type, title, text }) => (
      <Alert
        key={id}
        alertLevel={type}
        title={title}
        text={text}
        onClose={() => closeAlert({ id })}
      />
    ))}
  </Fragment>
);

export const mapStateToProps = (state) => ({
  alerts: getAllAlerts(state),
});

export const mapDispatchToProps = {
  closeAlert: removeAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(Alerts);
